import { ACTION_TYPES, MUTATION_TYPES } from './types';
import visitRegistryService from '../api';
import { getSupervisedInfo } from '../../provider/api';
import compensatoryServiceStatus from '@/utils/constants/compensatoryServiceStatus.js';
import visitTypes from '@/utils/constants/visitTypes.js';

export default {
  async [ACTION_TYPES.RESET](context) {
    context.commit(MUTATION_TYPES.RESET);
  },
  async [ACTION_TYPES.GET_ACADEMIC_YEARS](context) {
    const academicYears = await visitRegistryService.getAcademicYears();
    context.commit(MUTATION_TYPES.SET_ACADEMIC_YEARS, academicYears);
  },
  async [ACTION_TYPES.GET_MONTHS](context, payload) {
    const { months, mappedMonths } = await visitRegistryService.getMonths(
      payload
    );
    context.commit(MUTATION_TYPES.SET_MONTHS_ORIGINAL, months);
    context.commit(MUTATION_TYPES.SET_MONTHS, mappedMonths);
  },
  async [ACTION_TYPES.GET_SPECIALIST](context, { payload }) {
    const specialist = await visitRegistryService.getSpecialists(
      payload,
      payload
    );

    context.commit(MUTATION_TYPES.SET_SPECIALIST, specialist);
  },
  async [ACTION_TYPES.GET_SUPERVISED_SPECIALISTS](context, payload) {
    const { data } = await getSupervisedInfo(
      payload.specialistId,
      payload.academicYearId,
      payload.companyId
    );
    const supervisedSpecialists = (data || []).map((x) => ({
      id: x.supervisedId,
      name: x.specialistName,
    }));
    context.commit(
      MUTATION_TYPES.SET_SUPERVISED_SPECIALISTS,
      supervisedSpecialists
    );
  },
  async [ACTION_TYPES.GET_PROVIDERS](context, { payload }) {
    const companies = await visitRegistryService.getCompanies(payload);
    context.commit(MUTATION_TYPES.SET_PROVIDERS, companies);
  },
  async [ACTION_TYPES.GET_SERVICES](context, payload) {
    const services = await visitRegistryService.getServices(payload);
    context.commit(MUTATION_TYPES.SET_SERVICES, services);
  },
  async [ACTION_TYPES.GET_CENTERS](context, payload) {
    const centers = await visitRegistryService.getCenters(payload);
    context.commit(MUTATION_TYPES.SET_CENTERS, centers);
  },
  async [ACTION_TYPES.GET_LOCATIONSTYPE](context) {
    const locationsType = await visitRegistryService.getLocationsType();
    context.commit(MUTATION_TYPES.SET_LOCATIONSTYPE, locationsType);
  },
  async [ACTION_TYPES.GET_LOCATION](context, payload) {
    context.dispatch('$_common/setLoading', null, { root: true });
    const locations = await visitRegistryService.getLocations(payload);
    context.commit(MUTATION_TYPES.SET_LOCATION, locations);
    context.dispatch('$_common/setLoading', null, { root: false });
  },
  async [ACTION_TYPES.SEARCH](context, payload) {
    context.dispatch('$_common/setLoading', null, { root: true });
    const results = await visitRegistryService.search(payload);
    context.commit(MUTATION_TYPES.SET_RESULTS, results);
    context.dispatch('$_common/setLoading', null, { root: false });
  },
  async [ACTION_TYPES.GET_ADDITIONAL_INFORMATION](context, item) {
    let itemData = { ...item };
    if (!item.isOpen) {
      const visits = await visitRegistryService.searchDetails(
        item.id,
        item.serviceDate,
        item.isEducativeService
      );

      itemData.visits = visits;
    }

    context.commit(MUTATION_TYPES.SET_ADDITIONAL_INFORMATION, itemData);
  },
  async [ACTION_TYPES.RESET_ADVANCED_FILTERS](context) {
    context.commit(MUTATION_TYPES.SET_SERVICES, []);
    context.commit(MUTATION_TYPES.SET_CENTERS, []);
    context.commit(MUTATION_TYPES.SET_LOCATION, []);
    context.commit(MUTATION_TYPES.SET_SUPERVISED_SPECIALISTS, []);
  },
  async [ACTION_TYPES.GET_VISIT_TYPES](
    context,
    { requestTypeId, disciplineTypeId, studentSieId }
  ) {
    const { data } = await visitRegistryService.getVistTypes(
      requestTypeId,
      disciplineTypeId
    );
    const compensatoryBalance = await getCompensatoryBalance(studentSieId);

    if (data) {
      context.commit(
        MUTATION_TYPES.SET_VISIT_TYPES,
        data.filter(
          (item) =>
            !(
              item.id === visitTypes.Visita_Educativa_Reposicion &&
              compensatoryBalance <= 0
            )
        )
      );
    }
  },
  async [ACTION_TYPES.GET_EDUCATION_VISIT_TYPES](
    context,
    { requestTypeId, disciplineTypeId, studentSieId }
  ) {
    const { data } = await visitRegistryService.getEducationVisitTypes(
      requestTypeId,
      disciplineTypeId
    );

    const compensatoryBalance = await getCompensatoryBalance(studentSieId);

    if (data) {
      context.commit(
        MUTATION_TYPES.SET_VISIT_TYPES,
        data.filter(
          (item) =>
            !(
              item.id === visitTypes.Visita_Educativa_Reposicion &&
              compensatoryBalance <= 0
            )
        )
      );
    }
  },
  async [ACTION_TYPES.GET_DOCUMENT_TYPES](context) {
    const { data } = await visitRegistryService.getDocumentTypes();
    if (data) {
      context.commit(MUTATION_TYPES.SET_DOCUMENT_TYPES, data);
    }
  },
  async [ACTION_TYPES.GET_VISIT_ABSENCE_REGISTRATION](context) {
    const { data } = await visitRegistryService.getVisitAbsenceRegistration();
    if (data) {
      context.commit(MUTATION_TYPES.SET_VISIT_ABSENCE_REGISTRATION, data);
    }
  },
  async [ACTION_TYPES.GET_PRACTITIONER](
    context,
    { studentServiceId, visitDate }
  ) {
    const { data } = await visitRegistryService.getPractitioner(
      studentServiceId,
      visitDate
    );
    if (data) {
      context.commit(MUTATION_TYPES.SET_PRACTITIONER, data);
    }
  },
  async [ACTION_TYPES.SAVE_VISIT]({ commit }, { formData, itemIndex, id }) {
    if (!id) {
      const { data: result } = await visitRegistryService.saveVisit(formData);
      if (result) {
        commit(MUTATION_TYPES.SET_VISIT_REGISTERED, { itemIndex, id: result });
      }
      return result;
    } else {
      return await visitRegistryService.saveEditVisit(formData);
    }
  },
  async [ACTION_TYPES.DELETE_VISIT]({ commit }, { id, index }) {
    if (id) {
      const { data: result } = await visitRegistryService.deleteVisit(id);
      if (result) {
        commit(MUTATION_TYPES.SET_DELETE_VISIT, index);
      }
    }
  },
  async [ACTION_TYPES.GET_VISIT_VALID_REPLACEMENT](
    { commit },
    { academicYearId, studentServiceId }
  ) {
    const {
      data: result,
    } = await visitRegistryService.getVisitValidReplacement(
      academicYearId,
      studentServiceId
    );
    if (result) {
      commit(MUTATION_TYPES.SET_VISIT_VALID_REPLACEMENT, result);
    }
  },
  async [ACTION_TYPES.GET_VISIT_VALID_REPOSITION](
    { commit },
    { academicYearId, studentServiceId }
  ) {
    const { data: result } = await visitRegistryService.getVisitValidReposition(
      academicYearId,
      studentServiceId
    );
    if (result) {
      commit(MUTATION_TYPES.SET_VISIT_VALID_REPOSITION, result);
    }
  },
  async [ACTION_TYPES.GET_FINALIZED_PERIOD](
    { commit },
    { academicYearId, month, specialistId, companyId, centerId }
  ) {
    const { data: result } = await visitRegistryService.isFinalizedPeriod(
      academicYearId,
      month,
      specialistId,
      companyId,
      centerId
    );
    commit(MUTATION_TYPES.SET_FINALIZED_PERIOD, result);
  },
  async [ACTION_TYPES.VISIT_VALIDATION_INFO](
    { commit },
    { studentServiceId, academicYearId, monthDate, centerId }
  ) {
    const { data: result } = await visitRegistryService.visitValidationInfo(
      studentServiceId,
      academicYearId,
      monthDate,
      centerId
    );
    commit(MUTATION_TYPES.SET_VISIT_VALIDATION_INFO, result);
    return result;
  },
  async [ACTION_TYPES.GET_SPECIALIST_REPLACEMENT](
    { commit },
    { academicYearId, disciplineId, companyId, admissionId, visitDate }
  ) {
    const {
      data: result,
    } = await visitRegistryService.getSpecialistReplacement(
      academicYearId,
      disciplineId,
      companyId,
      admissionId,
      visitDate
    );
    commit(MUTATION_TYPES.SET_SPECIALIST_REPLACEMENT, result);
  },
  async [ACTION_TYPES.GET_VISITS](
    context,
    {
      studentServiceIds,
      month,
      periodAcademicYear,
      compensatoryRequestType,
      companyId,
    }
  ) {
    const { data } = await visitRegistryService.getVisits(
      studentServiceIds,
      month,
      periodAcademicYear,
      compensatoryRequestType,
      companyId
    );
    if (data) {
      context.commit(MUTATION_TYPES.SET_VISIT_LIST, data);
    }
  },
  async [ACTION_TYPES.GET_VISIT_LOCATION]({ commit }) {
    const result = await visitRegistryService.getLocationsType();
    commit(MUTATION_TYPES.SET_VISIT_LOCATION, result);
  },
  async [ACTION_TYPES.GET_VISIT_REGION](
    { commit },
    { academicYearId, companyId }
  ) {
    const { data: result } = await visitRegistryService.getVisitRegion(
      academicYearId,
      companyId
    );
    commit(MUTATION_TYPES.SET_VISIT_REGION, result);
  },
  async [ACTION_TYPES.GET_VISIT_DISTRICT](
    { commit },
    { academicYearId, regionId, companyId }
  ) {
    const { data: result } = await visitRegistryService.getVisitDistrict(
      academicYearId,
      regionId,
      companyId
    );
    commit(MUTATION_TYPES.SET_VISIT_DISTRICT, result);
  },
  async [ACTION_TYPES.GET_VISIT_SCHOOL](
    { commit },
    { academicYearId, regionId, districtId, companyId }
  ) {
    const { data: result } = await visitRegistryService.getVisitSchool(
      academicYearId,
      regionId,
      districtId,
      companyId
    );
    commit(MUTATION_TYPES.SET_VISIT_SCHOOL, result);
  },
  async [ACTION_TYPES.GET_VISIT_MUNICIPALITIES](
    { commit },
    { academicYearId, locationTypeId, companyId }
  ) {
    const { data: result } = await visitRegistryService.getVisitMunicipalities(
      academicYearId,
      locationTypeId,
      companyId
    );
    commit(MUTATION_TYPES.SET_VISIT_MUNICIPALITIES, result);
  },
  async [ACTION_TYPES.GET_VISIT_CENTERS](
    { commit },
    { academicYearId, municipalityId, companyId }
  ) {
    const { data: result } = await visitRegistryService.getVisitCenters(
      academicYearId,
      municipalityId,
      companyId
    );
    commit(MUTATION_TYPES.SET_VISIT_CENTER, result);
  },
  async [ACTION_TYPES.GET_VISIT_LOCATION_SERVICES](
    { commit },
    { academicYearId, locationTypeId, municipalityId, companyId }
  ) {
    const {
      data: result,
    } = await visitRegistryService.getVisitLocationServices(
      academicYearId,
      locationTypeId,
      municipalityId,
      companyId
    );
    commit(MUTATION_TYPES.SET_VISIT_LOCATION_SERVICE, result);
  },
  async [ACTION_TYPES.GET_SPECIALIST]({ commit }, payload) {
    const specialists = await visitRegistryService.getSpecialists(
      payload,
      payload
    );
    commit(MUTATION_TYPES.SET_SPECIALIST, specialists);
  },

  [ACTION_TYPES.SET_FILTERED_PERIOD]({ commit }, payload) {
    commit(MUTATION_TYPES.SET_FILTERED_PERIOD, payload);
  },

  [ACTION_TYPES.SET_CLEAR_CATALOG]({ commit }, payload) {
    commit(MUTATION_TYPES.SET_CLEAR_CATALOG, payload);
  },
  [ACTION_TYPES.SET_FILTER_PROP]({ commit }, payload) {
    commit(MUTATION_TYPES.SET_FILTER_PROP, payload);
  },
};

async function getCompensatoryBalance(studentSieId) {
  const {
    data: CompensatoryBalance,
  } = await visitRegistryService.getEducationalCompensatoryServiceBalance(
    studentSieId,
    compensatoryServiceStatus.Aprobado
  );
  return CompensatoryBalance;
}
